module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('h5', [_vm._v("パーツ一覧")]), _c('div', {
    staticClass: "part-area panel-group"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "panel panel-default",
      attrs: {
        "draggable": "true",
        "type": item.type
      },
      on: {
        "dragstart": _vm.dragStart
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-1 icon"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "text"),
        expression: "item.type === `text`"
      }],
      staticClass: "fa fa-item fa-font",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "textarea"),
        expression: "item.type === `textarea`"
      }],
      staticClass: "fa fa-item fa-align-justify",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "dropdown"),
        expression: "item.type === `dropdown`"
      }],
      staticClass: "fa fa-item fa-chevron-circle-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "checkbox"),
        expression: "item.type === `checkbox`"
      }],
      staticClass: "fa fa-item fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "radio"),
        expression: "item.type === `radio`"
      }],
      staticClass: "fa fa-item fa-dot-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "address"),
        expression: "item.type === `address`"
      }],
      staticClass: "fa fa-item fa-home",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "date"),
        expression: "item.type === `date`"
      }],
      staticClass: "fa fa-item fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "file"),
        expression: "item.type === `file`"
      }],
      staticClass: "fa fa-item fa-clipboard",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('div', {
      staticClass: "col-xs-11"
    }, [_c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "text"),
        expression: "item.type === `text`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("1行テキストボックス")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "textarea"),
        expression: "item.type === `textarea`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("複数行テキストボックス")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "dropdown"),
        expression: "item.type === `dropdown`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("ドロップダウンリスト")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "checkbox"),
        expression: "item.type === `checkbox`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("チェックボックス")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "radio"),
        expression: "item.type === `radio`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("ラジオボタン")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "address"),
        expression: "item.type === `address`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("住所")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "date"),
        expression: "item.type === `date`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("日付")]), _c('h5', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type === "file"),
        expression: "item.type === `file`"
      }],
      staticClass: "panel-title"
    }, [_vm._v("ファイル添付")])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8010e578","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/form/part/ItemSource.vue
// module id = 608
// module chunks = 1